import moment from 'moment-timezone';
import { IVolunteerShift } from '../../../../../../queries/Volunteer';

export interface EventWindowShiftInput {
	startDate?: string;
	startTime?: string;
	endDate?: string;
	endTime?: string;
	timezone?: string;
	shiftLengthMinutes: number;
	weekdays?: number[];
}

const DATE_FMT = 'YYYY/MM/DD';

export function generateShiftsFromEventWindow(input: EventWindowShiftInput): Partial<IVolunteerShift>[] {
	const { startDate, startTime, endTime, shiftLengthMinutes, weekdays } = input;
	if (!startDate || !startTime || !endTime || shiftLengthMinutes <= 0) {
		return [];
	}
	const zone = input.timezone || moment.tz.guess();
	const endDate = input.endDate || startDate;
	const rangeStart = moment.tz(startDate, DATE_FMT, zone);
	const rangeEnd = moment.tz(endDate, DATE_FMT, zone);
	if (!rangeStart.isValid() || !rangeEnd.isValid() || rangeEnd.isBefore(rangeStart, 'day')) {
		return [];
	}
	const wanted = weekdays && weekdays.length ? new Set(weekdays) : null;

	const shifts: Partial<IVolunteerShift>[] = [];
	const day = rangeStart.clone();
	while (!day.isAfter(rangeEnd, 'day')) {
		if (!wanted || wanted.has(day.day())) {
			const dayStr = day.format(DATE_FMT);
			const windowStart = moment.tz(`${dayStr} ${startTime}`, `${DATE_FMT} HH:mm:ss`, zone);
			const windowEnd = moment.tz(`${dayStr} ${endTime}`, `${DATE_FMT} HH:mm:ss`, zone);
			let cursor = windowStart.clone();
			while (cursor.isBefore(windowEnd)) {
				const next = moment.min(cursor.clone().add(shiftLengthMinutes, 'minutes'), windowEnd);
				shifts.push({ startAt: cursor.toISOString(), endAt: next.toISOString() });
				cursor = next;
			}
		}
		day.add(1, 'day');
	}
	return shifts;
}
